import React, { Component } from "react";
import { Helmet } from "react-helmet";
import logo from "../../assets/logo.png";
import Navbar from "../Navbar/Navbar";
import ScheduleOfChargesContent from "./ScheduleOfChargesContent";
import BottomBar from "../BottomBar/BottomBar";
class ScheduleOfCharges extends Component {
  render() {
    return (
      <div id="scheduleofcharges" className="main">
        <Helmet>
          <title>Schedule of Charges | MoneyMonk</title>
          <meta name="description" content="View the complete schedule of charges for MoneyMonk personal loans including processing fees, interest rates, and penalties." />
          <link rel="canonical" href="https://moneymonkapp.in/scheduleofcharges" />
        </Helmet>
        <Navbar imageData={logo} />
        <ScheduleOfChargesContent />
        <BottomBar />
      </div>
    );
  }
}

export default ScheduleOfCharges;
